<template>
  <div style="padding: 20px 0">
    <el-form :model="formData" :rules="formRules" ref="formRef" size="small" label-width="80px" style="text-align: left; padding-right: 20px">
      <el-form-item label="上级菜单">
        <el-select v-model="formData.pid" placeholder="请选择" style="width: 320px">
          <el-option v-for="item in topMenu" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称" prop="name" :error="errMsg.name">
        <el-input v-model="formData.name" style="width: 320px"> </el-input>
      </el-form-item>
      <el-form-item label="路由" prop="route" :error="errMsg.route">
        <el-input v-model="formData.route" style="width: 320px"> </el-input>
      </el-form-item>
      <el-form-item label="图标" prop="icon">
        <el-input v-model="formData.icon" style="width: 320px"> </el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input v-model="formData.sort" style="width: 320px"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveData">保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'authMenuSave',
  data() {
    return {
      errMsg: {},
      topMenu: [],
      formData: {},
      formRules: {
        name: [{ required: true, message: '菜单名称不能为空', trigger: 'blur' }],
        route: [{ required: true, message: '路径不能为空', trigger: 'blur' }]
      }
    };
  },
  methods: {
    //保存
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (vaild) {
          this.initErrMsg();
          await this.$api.auth.menuSave(this.formData).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.$emit('callMethod');
            } else {
              for (let k in res.data) {
                this.errMsg[k] = res.data[k];
              }
            }
          });
        }
      });
    },
    //父页面传数据
    setData(topMenu, menuData) {
      if (topMenu.length > 0) {
        this.topMenu = Object.assign([], topMenu);
      }
      this.topMenu.unshift({ id: 0, name: '一级菜单' });
      this.initErrMsg();
      this.$refs.formRef.clearValidate();
      if (menuData != undefined) {
        this.formData = menuData;
      } else {
        this.formData = { pid: 0, name: '', route: '', icon: '', sort: 0 };
      }
    },
    //初始化错误信息对象
    initErrMsg() {
      this.errMsg = {};
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '');
      });
    }
  }
};
</script>
